import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpService } from '../services/http.service';
import { LanguageService } from '../services/language.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.sass']
})
export class NavigationComponent implements OnInit, OnDestroy {

  langObsSubscribe: any;
  labelsObsSubscribe: any;
  labels: any;
  active: string;

  urlPl: Array<string> = [
    'rolnictwo', 'transport', 'o-firmie', 'usługi', 'galeria', 'kontakt'
  ];
  urlEn: Array<string> = [
    'agriculture', 'transport', 'about', 'services', 'gallery', 'contact'
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpService,
    private languageService: LanguageService) { }

  ngOnInit() {
    this.langObsSubscribe = this.languageService.languageObs().subscribe(lang => {
      if (this.route.snapshot.url.length > 1) {
        const segment0 = this.route.snapshot.url[0].path;
        const segment1 = this.route.snapshot.url[1].path;

        const serviceType = this.urlEn[this.urlPl.indexOf(segment0)];
        const content = this.urlEn[this.urlPl.indexOf(segment1)];

        if (this.labelsObsSubscribe === undefined) {
          this.labelsObsSubscribe = this.http.labelsObservable().subscribe((labels: object) => {

            this.active = content;
            this.labels = labels;

          });
        }

        this.http.getText(content, lang, serviceType);
        this.http.getLabels('navigation-labels', lang);
      }
    });
  }

  ngOnDestroy() {
    this.langObsSubscribe.unsubscribe();
    this.labelsObsSubscribe.unsubscribe();
  }

  changeRoute(page: string) {
    const previousPath = this.route.snapshot.url[0].path;
    this.router.navigate([previousPath + '/' + page]);
  }

}
